// extracted by mini-css-extract-plugin
export default {"main":"Checklist_main__iRPlk","check":"Checklist_check__Y6t7b","bullet":"Checklist_bullet__D+o8Q"};